<template>
    <div class="container-fluid">
        <div class="container" v-if="title">
            <div class="row">
                <div class="mission-container">
                    <p class="caption">{{ title }}</p>            
                </div>
            </div>
        </div>
        <div class="container mt-5">
            <div class="row">
                <div class="text-center">
                    <div class="thumbnail-wrapper">
                        <img 
                            :src="imageSrc" 
                            class="infographic-thumbnail"
                            @click="openLightbox"
                        />
                        <div class="zoom-icon-overlay" @click="openLightbox">
                            <font-awesome-icon icon="search-plus" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <transition name="lightbox-fade">
            <div v-if="isLightboxOpen" class="lightbox-overlay" @click="closeLightbox">
                <img 
                    :src="imageSrc" 
                    class="lightbox-image"
                    @click="closeLightbox"
                />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'BlockInfographic',
    props: {
        title: {
            type: String,
            required: false
        },
        infographic: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isLightboxOpen: false
        };
    },
    computed: {
        imageSrc() {
            return require(`@/assets/${this.infographic}`);
        }
    },
    methods: {
        openLightbox() {
            this.isLightboxOpen = true;
            document.addEventListener('keydown', this.handleEscKey);
        },
        closeLightbox() {
            this.isLightboxOpen = false;
            document.removeEventListener('keydown', this.handleEscKey);
        },
        handleEscKey(event) {
            if (event.key === 'Escape') {
                this.closeLightbox();
            }
        }
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.handleEscKey);
    }
};
</script>

<style scoped>
.infographic-thumbnail {
    max-height: min(75vh, 38em);
    width: auto;
    max-width: 100%;
    border-radius: 6px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.2);
    cursor: zoom-in;
    transition: transform 0.2s ease;
}

.thumbnail-wrapper {
    position: relative;
    display: inline-block;
}

.infographic-thumbnail:hover {
    transform: scale(1.02);
}

.zoom-icon-overlay {
    position: absolute;
    bottom: 12px;
    right: 12px;
    background-color: #333;
    border-radius: 4px;
    padding: 8px 10px;
    cursor: zoom-in;
    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
    transition: background-color 0.2s ease, transform 0.2s ease;
    font-size: 18px;
    color:  rgba(255, 255, 255, 0.9);
}

.zoom-icon-overlay:hover {
    /* background-color: rgba(255, 255, 255, 1); */
    transform: scale(1.1);
}

.lightbox-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: zoom-out;
    padding: 1rem;
}

.lightbox-image {
    max-width: 95vw;
    max-height: 95vh;
    width: auto;
    height: auto;
    object-fit: contain;
    box-shadow: 0 10px 40px rgba(0,0,0,0.5);
    cursor: zoom-out;
}

@media (max-width: 768px) {
    .lightbox-image {
        max-width: 98vw;
        max-height: 98vh;
    }
}

.lightbox-fade-enter-active,
.lightbox-fade-leave-active {
    transition: opacity 0.2s ease;
}

.lightbox-fade-enter-active .lightbox-image,
.lightbox-fade-leave-active .lightbox-image {
    transition: transform 0.2s ease;
}

.lightbox-fade-enter-from,
.lightbox-fade-leave-to {
    opacity: 0;
}

.lightbox-fade-enter-from .lightbox-image {
    transform: scale(0.9);
}

.lightbox-fade-leave-to .lightbox-image {
    transform: scale(0.9);
}


.investment-section {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    min-width: 73.125rem;
    background: white;
}

.article-container1 {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    gap: 1.875rem;
    align-items: flex-end;
    justify-content: flex-start;
}

.container-with-image {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    align-items: center;
    align-self: stretch;
    justify-content: flex-start;
}

.article-container {
    box-sizing: border-box;
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    padding: 58px 4.9375rem 2.9375rem;
}

.hero-title {
    box-sizing: border-box;
    flex: 0 0 auto;
    max-width: 18.875rem;
    font: 700 4rem/4rem Roboto;
    color: white;
}

.flex-container {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    margin-top: 0.5rem;
}

.button-read-more {
    box-sizing: border-box;
    flex: 0 0 auto;
    font: 400 0.75rem Gothic A1;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.20000000000000004em;
}

.svg-container1 {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    width: 1.5rem;
    height: 1.5rem;
    margin-left: 0.875rem;
    color: #ffffff;
}

.content-wrapper {
    box-sizing: border-box;
    flex: 0 0 auto;
    margin-left: 1.875rem;
}

.image-container5 {
    box-sizing: border-box;
    display: block;
    width: 35.625rem;
    max-width: initial;
    border: none;
}

.content-section {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: row;
    gap: 1.875rem;
    align-items: center;
    align-self: stretch;
    justify-content: space-between;
}

.flexbox-container {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
}

.image-container2 {
    box-sizing: border-box;
    display: block;
    flex: 0 0 auto;
    width: 16.875rem;
    max-width: initial;
    height: 15.9375rem;
    border: none;
}

.image-container3 {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.image-container {
    box-sizing: border-box;
    display: block;
    flex: 0 0 auto;
    width: 29.375rem;
    max-width: initial;
    height: 15.9375rem;
    border: none;
}

.image-container4 {
    box-sizing: border-box;
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
}

.image-container1 {
    box-sizing: border-box;
    display: block;
    flex: 0 0 auto;
    width: 23.125rem;
    max-width: initial;
    height: 15.9375rem;
    border: none;
}

.img-content-8fa07e13 {
    content: url("@/assets/postcard.png");
    background-repeat: no-repeat;
    background-size: cover;
    transform: scale(1.4);
    /* border: 0.5rem solid white; */
    /* box-shadow: 0 4px 20px rgba(0,0,0,0.2); */
    /* border-radius: 0.7rem; */
    /* background: white; */
}

.img-content-87d2b90e {
    content: url("@/assets/front_3.jpg");
    background-repeat: no-repeat;
    background-size: cover;
}

.img-content-142be835 {
    content: url("@/assets/front_7.jpg");
    background-repeat: no-repeat;
    background-size: cover;
}

.img-content-9261cda8 {
    content: url("@/assets/front_4.jpg");
    background-repeat: no-repeat;
    background-size: cover;
}

.article-container {
    background: url("@/assets/front_6.jpg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
}
</style>
